import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import "./OtherServices.css"; 
import { Link } from "react-router-dom";

const OtherServices = () => {
  const services = [
    {
      icon: "Images/pricing-icon/icon-waveform.svg",
      title: "Rights Management",
      desc: "We help you own & protect your copyrights.",
      color: "#8b5cf6",
      link: "/music-right-management",
    },
    {
      icon: "Images/pricing-icon/icon-clapper.svg",
      title: "Youtube Promotion",
      desc: "We help you to promote your songs on Youtube.",
      color: "#ef4444",
      link: "/youtube-promotion",
    },
    {
      icon: "Images/pricing-icon/icon-announcement.svg",
      title: "Music Publishing",
      desc: "Earn more through publishing rights.",
      color: "#f59e0b",
      link: "/music-publishing",
    },
    {
      icon: "Images/pricing-icon/icon-unlimited.svg",
      title: "Digital Distribution",
      desc: "Global distribution on 150+ platforms.",
      color: "#10b981",
      link: "/digital-distribution",
    },
  ];

  return (
    <section className="other-services-section">
      <Container fluid className="px-5">
        <Row className="align-items-stretch">
          {/* Left: Header */}
          <Col lg={3} className="header-col mb-4 mb-lg-0">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <h6 className="text-uppercase text-purple mb-3"><mark>OUR SERVICES</mark></h6>
              <h2 className="services-main-title text-white">
                Everything You Need <br />
                To Grow Your <br />
                Music Career
              </h2>
            </motion.div>
          </Col>

          {/* Middle: Services Grid */}
          <Col lg={6} className="services-grid-col mb-4 mb-lg-0">
            <div className="services-container">
              {services.map((service, index) => (
                <motion.div 
                  key={index} 
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <Link 
                    to={service.link} 
                    className="service-box" 
                    style={{ textDecoration: 'none', color: 'inherit', flex: 1 }}
                  >
                    <div
                      className="service-icon-wrapper"
                      style={{ backgroundColor: `${service.color}15` }}
                    >
                      <img
                        src={service.icon}
                        alt={service.title}
                        className="service-icon"
                      />
                    </div>
                    <h4 className="service-title">{service.title}</h4>
                    <p className="service-desc">{service.desc}</p>
                  </Link>
                </motion.div>
              ))}
            </div>
          </Col>

          {/* Right: Why Work With Us */}
          <Col lg={3} className="why-us-col">
            <motion.div 
              className="why-us-card"
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <div className="why-us-content">
                <h3 className="why-us-title"><mark>Why Work With Us?</mark></h3>
                <p className="why-us-desc">
                  Come on, we will help you sell your music worldwide & get
                  paid.
                </p>
                <ul className="why-us-list">
                  <li>
                    <span className="check-icon">✓</span> Worldwide Reach Across Major Platforms
                  </li>
                  <li>
                    <span className="check-icon">✓</span> Transparent Royalties & Payments
                  </li>
                  <li>
                    <span className="check-icon">✓</span> 100% Secure Rights Protection
                  </li>
                  <li>
                    <span className="check-icon">✓</span> Keep 100% Ownership of Your Music
                    
                  </li>
                </ul>
                <a 
                  href="https://dashboard.fttunes.com/register.php" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="btn-work-with-us button_button__MFmXH button_color__bLscP"
                  style={{ textDecoration: 'none' }}
                >
                  WORK WITH US <span className="arrow">→</span>
                </a>
              </div>
              <div className="why-us-bg-mic"></div>
            </motion.div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default OtherServices;
